// frontend/src/constants/cartConstants.js

/* -------------------------------------------------------------------------- */
/*                                   Reads                                    */
/* -------------------------------------------------------------------------- */

export const CART_GET_REQUEST = "CART_GET_REQUEST";
export const CART_GET_SUCCESS = "CART_GET_SUCCESS";
export const CART_GET_FAIL = "CART_GET_FAIL";

export const CART_SUMMARY_REQUEST = "CART_SUMMARY_REQUEST";
export const CART_SUMMARY_SUCCESS = "CART_SUMMARY_SUCCESS";
export const CART_SUMMARY_FAIL = "CART_SUMMARY_FAIL";

export const CART_VALIDATE_REQUEST = "CART_VALIDATE_REQUEST";
export const CART_VALIDATE_SUCCESS = "CART_VALIDATE_SUCCESS";
export const CART_VALIDATE_FAIL = "CART_VALIDATE_FAIL";

export const CART_QUOTE_REQUEST = "CART_QUOTE_REQUEST";
export const CART_QUOTE_SUCCESS = "CART_QUOTE_SUCCESS";
export const CART_QUOTE_FAIL = "CART_QUOTE_FAIL";
export const CART_QUOTE_RESET = "CART_QUOTE_RESET";

export const CART_REFRESH_REQUEST = "CART_REFRESH_REQUEST";
export const CART_REFRESH_SUCCESS = "CART_REFRESH_SUCCESS";
export const CART_REFRESH_FAIL = "CART_REFRESH_FAIL";

/* -------------------------------------------------------------------------- */
/*                                Mutations                                   */
/* -------------------------------------------------------------------------- */

export const CART_ADD_ITEM_REQUEST = "CART_ADD_ITEM_REQUEST";
export const CART_ADD_ITEM_SUCCESS = "CART_ADD_ITEM_SUCCESS";
export const CART_ADD_ITEM_FAIL = "CART_ADD_ITEM_FAIL";

export const CART_SET_ITEM_QTY_REQUEST = "CART_SET_ITEM_QTY_REQUEST";
export const CART_SET_ITEM_QTY_SUCCESS = "CART_SET_ITEM_QTY_SUCCESS";
export const CART_SET_ITEM_QTY_FAIL = "CART_SET_ITEM_QTY_FAIL";

export const CART_INCREMENT_ITEM_REQUEST = "CART_INCREMENT_ITEM_REQUEST";
export const CART_INCREMENT_ITEM_SUCCESS = "CART_INCREMENT_ITEM_SUCCESS";
export const CART_INCREMENT_ITEM_FAIL = "CART_INCREMENT_ITEM_FAIL";

export const CART_DECREMENT_ITEM_REQUEST = "CART_DECREMENT_ITEM_REQUEST";
export const CART_DECREMENT_ITEM_SUCCESS = "CART_DECREMENT_ITEM_SUCCESS";
export const CART_DECREMENT_ITEM_FAIL = "CART_DECREMENT_ITEM_FAIL";

export const CART_REMOVE_ITEM_REQUEST = "CART_REMOVE_ITEM_REQUEST";
export const CART_REMOVE_ITEM_SUCCESS = "CART_REMOVE_ITEM_SUCCESS";
export const CART_REMOVE_ITEM_FAIL = "CART_REMOVE_ITEM_FAIL";

export const CART_CLEAR_REQUEST = "CART_CLEAR_REQUEST";
export const CART_CLEAR_SUCCESS = "CART_CLEAR_SUCCESS";
export const CART_CLEAR_FAIL = "CART_CLEAR_FAIL";

export const CART_REPLACE_REQUEST = "CART_REPLACE_REQUEST";
export const CART_REPLACE_SUCCESS = "CART_REPLACE_SUCCESS";
export const CART_REPLACE_FAIL = "CART_REPLACE_FAIL";

export const CART_MERGE_REQUEST = "CART_MERGE_REQUEST";
export const CART_MERGE_SUCCESS = "CART_MERGE_SUCCESS";
export const CART_MERGE_FAIL = "CART_MERGE_FAIL";

export const CART_APPLY_PROMO_CODE_REQUEST =
  "CART_APPLY_PROMO_CODE_REQUEST";
export const CART_APPLY_PROMO_CODE_SUCCESS =
  "CART_APPLY_PROMO_CODE_SUCCESS";
export const CART_APPLY_PROMO_CODE_FAIL = "CART_APPLY_PROMO_CODE_FAIL";

export const CART_REMOVE_PROMO_CODE_REQUEST =
  "CART_REMOVE_PROMO_CODE_REQUEST";
export const CART_REMOVE_PROMO_CODE_SUCCESS =
  "CART_REMOVE_PROMO_CODE_SUCCESS";
export const CART_REMOVE_PROMO_CODE_FAIL = "CART_REMOVE_PROMO_CODE_FAIL";

/* -------------------------------------------------------------------------- */
/*                                  Cleanup                                   */
/* -------------------------------------------------------------------------- */

export const CART_REMOVE_UNAVAILABLE_REQUEST =
  "CART_REMOVE_UNAVAILABLE_REQUEST";
export const CART_REMOVE_UNAVAILABLE_SUCCESS =
  "CART_REMOVE_UNAVAILABLE_SUCCESS";
export const CART_REMOVE_UNAVAILABLE_FAIL = "CART_REMOVE_UNAVAILABLE_FAIL";

export const CART_REMOVE_PRICE_CHANGED_REQUEST =
  "CART_REMOVE_PRICE_CHANGED_REQUEST";
export const CART_REMOVE_PRICE_CHANGED_SUCCESS =
  "CART_REMOVE_PRICE_CHANGED_SUCCESS";
export const CART_REMOVE_PRICE_CHANGED_FAIL = "CART_REMOVE_PRICE_CHANGED_FAIL";

/* -------------------------------------------------------------------------- */
/*                             Checkout draft state                           */
/* -------------------------------------------------------------------------- */

export const CART_GET_CHECKOUT_REQUEST = "CART_GET_CHECKOUT_REQUEST";
export const CART_GET_CHECKOUT_SUCCESS = "CART_GET_CHECKOUT_SUCCESS";
export const CART_GET_CHECKOUT_FAIL = "CART_GET_CHECKOUT_FAIL";

export const CART_SAVE_FULFILLMENT_METHOD_REQUEST =
  "CART_SAVE_FULFILLMENT_METHOD_REQUEST";
export const CART_SAVE_FULFILLMENT_METHOD_SUCCESS =
  "CART_SAVE_FULFILLMENT_METHOD_SUCCESS";
export const CART_SAVE_FULFILLMENT_METHOD_FAIL =
  "CART_SAVE_FULFILLMENT_METHOD_FAIL";

export const CART_SAVE_CUSTOMER_DETAILS_REQUEST =
  "CART_SAVE_CUSTOMER_DETAILS_REQUEST";
export const CART_SAVE_CUSTOMER_DETAILS_SUCCESS =
  "CART_SAVE_CUSTOMER_DETAILS_SUCCESS";
export const CART_SAVE_CUSTOMER_DETAILS_FAIL =
  "CART_SAVE_CUSTOMER_DETAILS_FAIL";

export const CART_SAVE_SHIPPING_ADDRESS_REQUEST =
  "CART_SAVE_SHIPPING_ADDRESS_REQUEST";
export const CART_SAVE_SHIPPING_ADDRESS_SUCCESS =
  "CART_SAVE_SHIPPING_ADDRESS_SUCCESS";
export const CART_SAVE_SHIPPING_ADDRESS_FAIL =
  "CART_SAVE_SHIPPING_ADDRESS_FAIL";

export const CART_SAVE_PICKUP_DETAILS_REQUEST =
  "CART_SAVE_PICKUP_DETAILS_REQUEST";
export const CART_SAVE_PICKUP_DETAILS_SUCCESS =
  "CART_SAVE_PICKUP_DETAILS_SUCCESS";
export const CART_SAVE_PICKUP_DETAILS_FAIL = "CART_SAVE_PICKUP_DETAILS_FAIL";

export const CART_SAVE_BILLING_OPTIONS_REQUEST =
  "CART_SAVE_BILLING_OPTIONS_REQUEST";
export const CART_SAVE_BILLING_OPTIONS_SUCCESS =
  "CART_SAVE_BILLING_OPTIONS_SUCCESS";
export const CART_SAVE_BILLING_OPTIONS_FAIL = "CART_SAVE_BILLING_OPTIONS_FAIL";

export const CART_SAVE_CHECKOUT_ACKNOWLEDGEMENTS_REQUEST =
  "CART_SAVE_CHECKOUT_ACKNOWLEDGEMENTS_REQUEST";
export const CART_SAVE_CHECKOUT_ACKNOWLEDGEMENTS_SUCCESS =
  "CART_SAVE_CHECKOUT_ACKNOWLEDGEMENTS_SUCCESS";
export const CART_SAVE_CHECKOUT_ACKNOWLEDGEMENTS_FAIL =
  "CART_SAVE_CHECKOUT_ACKNOWLEDGEMENTS_FAIL";

export const CART_SAVE_PAYMENT_METHOD_REQUEST =
  "CART_SAVE_PAYMENT_METHOD_REQUEST";
export const CART_SAVE_PAYMENT_METHOD_SUCCESS =
  "CART_SAVE_PAYMENT_METHOD_SUCCESS";
export const CART_SAVE_PAYMENT_METHOD_FAIL = "CART_SAVE_PAYMENT_METHOD_FAIL";

export const CART_SAVE_CHECKOUT_NOTES_REQUEST =
  "CART_SAVE_CHECKOUT_NOTES_REQUEST";
export const CART_SAVE_CHECKOUT_NOTES_SUCCESS =
  "CART_SAVE_CHECKOUT_NOTES_SUCCESS";
export const CART_SAVE_CHECKOUT_NOTES_FAIL = "CART_SAVE_CHECKOUT_NOTES_FAIL";

export const CART_RESET_CHECKOUT_REQUEST = "CART_RESET_CHECKOUT_REQUEST";
export const CART_RESET_CHECKOUT_SUCCESS = "CART_RESET_CHECKOUT_SUCCESS";
export const CART_RESET_CHECKOUT_FAIL = "CART_RESET_CHECKOUT_FAIL";

/* -------------------------------------------------------------------------- */
/*                                  Resets                                    */
/* -------------------------------------------------------------------------- */

export const CART_RESET_ERROR = "CART_RESET_ERROR";
export const CART_RESET_META = "CART_RESET_META";
export const CART_RESET_STATE = "CART_RESET_STATE";
